import script from "./WithdrawSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawSummary.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawSummary.vue?vue&type=style&index=0&id=ff09d6f2&scoped=true&lang=css"
script.__scopeId = "data-v-ff09d6f2"

export default script